import { render, staticRenderFns } from "./LoggerAllocation.vue?vue&type=template&id=596b0f8e&"
import script from "./LoggerAllocation.vue?vue&type=script&lang=js&"
export * from "./LoggerAllocation.vue?vue&type=script&lang=js&"
import style0 from "./LoggerAllocation.vue?vue&type=style&index=0&id=596b0f8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports